<template>
  <p class="login-card__steps">
    <span class="steps__step" :class="{'steps__step--active': step===1}">01</span>
    <span class="steps__step" :class="{'steps__step--active': step===2}">02</span>
    <span class="steps__step" :class="{'steps__step--active': step===3}">03</span>
    <span class="steps__step" :class="{'steps__step--active': step===4}">04</span>
    <!-- <span class="steps__step" :class="{'steps__step&#45;&#45;active': step===5}">05</span>-->
  </p>
</template>
<script>
export default {
  props: {
    step: {
      type: Number,
      default: 1,
    }
  },
  mounted() {
  },
};
</script>
<style scoped>
</style>
